import { Stack, Text } from "@mantine/core";
import { DataResult, EntityClientAction, FakeProgressBar, useExecuteProc, useExportToExcel } from "@mcurros2/microm";
import { useEffect, useState } from "react";
import { Reportes } from "./Reportes";

export const ExportarExcelPorServiciosModal = ({ reportes, onClose }: { reportes: Reportes, onClose: () => void }) => {
    const getReportes = useExecuteProc(reportes, reportes.def.procs.repo_qryReportesPorServicio);

    const [datos0, setDatos0] = useState<DataResult>();
    const [datos1, setDatos1] = useState<DataResult>();
    const [datos2, setDatos2] = useState<DataResult>();

    const { exportToExcel } = useExportToExcel({
        data: [datos0!, datos1!, datos2!],
        dataResultNames: ['Hoja1', 'Precios', 'Novedades']
    });

    useEffect(() => {
        async function fetchData() {
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.def.columns.dt_fecha_desde.value,
                dt_fecha_hasta: reportes.def.columns.dt_fecha_hasta.value,
                c_autorizacion_directa_status_id: reportes.def.columns.c_autorizacion_directa_status_id.value
            });
        }
        fetchData();
    }, [reportes.def.columns.c_cliente_id.value, reportes.def.columns.dt_fecha_desde.value, reportes.def.columns.dt_fecha_hasta.value, reportes.def.columns.c_autorizacion_directa_status_id.value]);

    useEffect(() => {
        if (!getReportes.status.loading && getReportes.status.data) {
            setDatos0(getReportes.status.data[0]);
            setDatos1(getReportes.status.data[1]);
            setDatos2(getReportes.status.data[2]);
        }
    }, [getReportes.status]);

    useEffect(() => {
        if (datos0 && datos1 && datos2) {
            exportToExcel();
            onClose();
        }
    }, [datos0, datos1, datos2]);

    return (
        <Stack>
            <Text>Generando archivo...</Text>
            <FakeProgressBar />
        </Stack>
    )
};


export const ACTExportarExcelPorServicios: EntityClientAction = {
    name: 'ACTExportarExcelPorServicios',
    label: 'Exportar Excel por Servicios',
    title: <Text fw={700}>Exportar Excel</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [],
    onClick: async ({ entity, modal, element, onClose }) => {
        const reportes = entity as Reportes;

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Exportar Excel por Servicios</Text>
            },
            focusOnClosed: element,
            content: <ExportarExcelPorServiciosModal reportes={reportes} onClose={() => modal.close()} />

        });

        return false;
    }
}